export const NEW_SUPPLIER_RESET = "NEW_SUPPLIER_RESET";
export const UPDATE_SUPPLIER_RESET = "UPDATE_SUPPLIER_RESET";
export const DELETE_SUPPLIER_RESET = "DELETE_SUPPLIER_RESET";
export const REMOVE_SUPPLIER_DETAILS = "REMOVE_SUPPLIER_DETAILS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SUPPLIERS_REQUEST = "SUPPLIERS_REQUEST";
export const SUPPLIERS_SUCCESS = "SUPPLIERS_SUCCESS";
export const SUPPLIERS_FAIL = "SUPPLIERS_FAIL";
export const NEW_SUPPLIER_REQUEST = "NEW_SUPPLIER_REQUEST";
export const NEW_SUPPLIER_SUCCESS = "NEW_SUPPLIER_SUCCESS";
export const NEW_SUPPLIER_FAIL = "NEW_SUPPLIER_FAIL";
export const UPDATE_SUPPLIER_REQUEST = "UPDATE_SUPPLIER_REQUEST";
export const UPDATE_SUPPLIER_SUCCESS = "UPDATE_SUPPLIER_SUCCESS";
export const UPDATE_SUPPLIER_FAIL = "UPDATE_SUPPLIER_FAIL";
export const DELETE_SUPPLIER_REQUEST = "DELETE_SUPPLIER_REQUEST";
export const DELETE_SUPPLIER_SUCCESS = "DELETE_SUPPLIER_SUCCESS";
export const DELETE_SUPPLIER_FAIL = "DELETE_SUPPLIER_FAIL";
export const SUPPLIER_DETAILS_REQUEST = "SUPPLIER_DETAILS_REQUEST";
export const SUPPLIER_DETAILS_SUCCESS = "SUPPLIER_DETAILS_SUCCESS";
export const SUPPLIER_DETAILS_FAIL = "SUPPLIER_DETAILS_FAIL";
export const SUPPLIER_SALES_REQUEST = "SUPPLIER_SALES_REQUEST";
export const SUPPLIER_SALES_SUCCESS = "SUPPLIER_SALES_SUCCESS";
export const SUPPLIER_SALES_FAIL = "SUPPLIER_SALES_FAIL";
